import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  Terminal,
  TerminalCreationPayload,
  TerminalUpdatePayload,
  update,
} from '../api/terminals'

export const terminalKeys = {
  create: ['terminals', 'create'] as const,
  update: ['terminals', 'update'] as const,
}

// Queries
export const useTerminalQuery = (
  id?: string,
  options?: QueryOptions<Terminal>,
): UseQueryResult<Terminal, any> => useResource<Terminal>('terminals', get, id, undefined, options)

export const useTerminalsQuery = (
  filters?: any,
  options?: QueryOptions<Terminal[]>,
): UseQueryResult<Terminal[], any> =>
  useResources<Terminal[], any>('terminals', fetch, filters, options)

// Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['terminals'])
}

export const useCreateMutation = (): UseMutationResult<Terminal, TerminalCreationPayload> =>
  useMutation(create, { mutationKey: terminalKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<Terminal, TerminalUpdatePayload> =>
  useMutation(update, {
    mutationKey: terminalKeys.update,
    onSuccess: onMutationSuccess,
  })
